import script from "./NewsComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewsComponent.vue?vue&type=script&setup=true&lang=ts"

import "./NewsComponent.vue?vue&type=style&index=0&id=304dd279&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-304dd279"]])

export default __exports__